module.exports = __webpack_public_path__ + "img/cybo_display_smartphone_small.6f58b65f.png";